import { SHOW_LOADER, HIDE_LOADER } from '../../actions/types'

const INITIAL_STATE = {
  loading: false
}

export default function loader(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, loading: true }
    case HIDE_LOADER:
      return { ...state, loading: false }
    default:
      return state
  }
}